// removed by extract-text-webpack-plugin
module.exports = {"sectionInner":"_2MYJi6Sm0diNk2Pln4WUfu"};


//////////////////
// WEBPACK FOOTER
// ./app/web/src/layout/Base.css
// module id = 427
// module chunks = 0